"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.hcvScreeningMessages = exports.HcvScreening = void 0;
const schema_1 = require("../../../../schema");
var HcvScreening;
(function (HcvScreening) {
    HcvScreening["POSITIVE"] = "POSITIVE";
    HcvScreening["NEGATIVE"] = "NEGATIVE";
    HcvScreening["IN_PROGRESS"] = "IN_PROGRESS";
})(HcvScreening || (exports.HcvScreening = HcvScreening = {}));
exports.hcvScreeningMessages = {
    [HcvScreening.POSITIVE]: {
        id: "ltx.phaseI.viralSerology.hcv.hcvScreening.POSITIVE",
        defaultMessage: "Pozitív"
    },
    [HcvScreening.NEGATIVE]: {
        id: "ltx.phaseI.viralSerology.hcv.hcvScreening.NEGATIVE",
        defaultMessage: "Negatív"
    },
    [HcvScreening.IN_PROGRESS]: {
        id: "ltx.phaseI.viralSerology.hcv.hcvScreening.IN_PROGRESS",
        defaultMessage: "Folyamatban"
    }
};
const hcvScreening = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HcvScreening.POSITIVE),
    schema_1.Schema.singleChoiceItem(HcvScreening.NEGATIVE),
    schema_1.Schema.singleChoiceItem(HcvScreening.IN_PROGRESS)
]).interpretation({ vocab: "ltx", code: "hepa_c_virus_screening" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ hcvScreening })
    .tag({ vocab: "snomed", code: "62944002" })
    .tag({ vocab: "snomed", code: "20135006" });
